import { useCurrentUser } from './useCurrentUser';
import { useAdmin } from './useAdmin';
import { isAnalyticsAccessible, getEnvironmentInfo } from '../lib/environmentConfig';

export const useAnalyticsAccess = () => {
  const { data: currentUser } = useCurrentUser();
  const { isAdmin } = useAdmin();
  const envInfo = getEnvironmentInfo();
  
  // Check if user has analytics access
  const hasAnalyticsAccess = isAnalyticsAccessible(currentUser) || isAdmin;
  
  return {
    hasAnalyticsAccess,
    canViewAnalytics: hasAnalyticsAccess,
    environmentInfo: envInfo,
    user: currentUser,
    isAdmin,
    accessReason: getAccessReason()
  };
  
  function getAccessReason(): string {
    if (envInfo.analyticsPublicAccess) {
      return `Public access (${envInfo.environment} environment)`;
    }

    if (isAdmin) {
      return 'Admin privileges';
    }

    return 'Access denied';
  }
};